/* LORVENI — drobne zachowania motywu (bez zależności) */
(function () {
  'use strict';

  // Szuflada mobilna: zamykanie przyciskiem X, Escape i po kliknięciu linku
  var drawer = document.getElementById('MenuDrawer');
  if (drawer) {
    var close = function () { drawer.removeAttribute('open'); document.body.classList.remove('menu-open'); };
    drawer.addEventListener('toggle', function () {
      document.body.classList.toggle('menu-open', drawer.open);
    });
    drawer.querySelectorAll('[data-menu-close], .menu-drawer-lorveni__nav a').forEach(function (el) {
      el.addEventListener('click', function () { setTimeout(close, 10); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.open) close(); });
  }

  // Nagłówek: cień po przewinięciu
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Sortowanie kolekcji bez przeładowania formularza
  document.querySelectorAll('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Subskrypcje (selling plans): zmiana ceny po wyborze planu / wariantu
  if (!customElements.get('selling-plan-selector')) {
    customElements.define('selling-plan-selector', class extends HTMLElement {
      connectedCallback() {
        try { this.prices = JSON.parse(this.querySelector('[data-plan-prices]').textContent); } catch (e) { this.prices = {}; }
        this.sectionId = this.dataset.section;
        // tryb kompaktowy (4+ planów): jedna opcja „Subskrypcja” + lista częstotliwości
        this.planRadio = this.querySelector('[data-plan-radio]');
        this.planSelect = this.querySelector('[data-plan-select]');
        this.freqBox = this.querySelector('[data-plan-freq]');
        this.descEl = this.querySelector('[data-plan-desc]');
        try { var d = this.querySelector('[data-plan-descs]'); this.descs = d ? JSON.parse(d.textContent) : {}; } catch (e) { this.descs = {}; }
        this.addEventListener('change', (e) => {
          if (e.target === this.planSelect) {
            if (this.planRadio) { this.planRadio.value = this.planSelect.value; this.planRadio.checked = true; }
            this.update();
          } else if (e.target.name === 'selling_plan') {
            this.update();
          }
        });
        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => this.update(), 0));
        }
        // widget aplikacji (Seal) wstrzykiwany asynchronicznie do formularza — usuwamy, żeby nie dublować wyboru
        if (this.hasAttribute('data-hide-app-widget')) {
          var form = document.getElementById(this.dataset.form);
          var purge = () => {
            document.querySelectorAll('.sealsubs-target-element, .sealsubs-container').forEach((el) => el.remove());
            if (form) form.querySelectorAll('input[name="selling_plan"]:not([form])').forEach((el) => el.remove());
          };
          purge();
          this.observer = new MutationObserver(purge);
          this.observer.observe(form || document.body, { childList: true, subtree: true });
        }
        this.update();
      }
      disconnectedCallback() { if (this.unsub) this.unsub(); if (this.observer) this.observer.disconnect(); }
      variantId() {
        var form = document.getElementById(this.dataset.form);
        var input = form ? form.querySelector('[name="id"]') : null;
        return input ? input.value : null;
      }
      update() {
        var vid = this.variantId();
        var map = (vid && this.prices[vid]) || null;
        var checked = this.querySelector('input[name="selling_plan"]:checked');
        if (this.planRadio && this.planSelect && this.planRadio.value !== this.planSelect.value) {
          this.planRadio.value = this.planSelect.value;
        }
        if (this.freqBox) this.freqBox.hidden = !(this.planRadio && this.planRadio.checked);
        if (this.planSelect && map) {
          Array.prototype.forEach.call(this.planSelect.options, (o) => {
            var name = o.dataset.name || o.textContent.split(' — ')[0];
            if (map[o.value] !== undefined) o.textContent = name + ' — ' + map[o.value];
          });
        }
        if (this.descEl && this.planSelect) {
          var desc = this.descs[this.planSelect.value] || '';
          this.descEl.textContent = desc;
          this.descEl.hidden = !desc;
        }
        this.querySelectorAll('.purchase-option').forEach((opt) => {
          var input = opt.querySelector('input');
          opt.classList.toggle('is-selected', input.checked);
          if (map) {
            var el = opt.querySelector('[data-plan-price]');
            var key = input.value || '';
            if (el && map[key] !== undefined) {
              var s = el.querySelector('s');
              el.setAttribute('data-plan-price', key);
              el.textContent = map[key];
              if (s && key !== '' && map[''] !== map[key]) el.insertAdjacentHTML('afterbegin', '<s>' + map[''] + '</s> ');
            }
          }
        });
        // cena główna w bloku „Cena” (Dawn pokazuje .price__sale tylko przy klasie price--on-sale)
        if (map && checked) {
          var key = checked.value || '';
          var price = map[key];
          var root = document.querySelector('#price-' + this.sectionId + ' .price');
          if (root && price) {
            if (!root.dataset.lorveniBase) root.dataset.lorveniBase = root.classList.contains('price--on-sale') ? '1' : '0';
            var baseSale = root.dataset.lorveniBase === '1';
            var planSale = key !== '' && map[''] !== price;
            var reg = root.querySelector('.price__regular .price-item--regular');
            var saleReg = root.querySelector('.price__sale s.price-item--regular');
            var sale = root.querySelector('.price__sale .price-item--sale');
            root.classList.toggle('price--on-sale', baseSale || planSale);
            root.classList.toggle('price--plan', planSale && !baseSale);
            if (planSale) {
              if (saleReg) saleReg.textContent = map[''];
              if (sale) sale.textContent = price;
            } else if (!baseSale) {
              if (reg) reg.textContent = price;
            } else if (sale) {
              sale.textContent = price;
            }
          }
        }
      }
    });
  }
  // Baner geolokalizacyjny (Zał. 1 pkt 9): wykrywanie przez Shopify /browsing_context_suggestions.json,
  // dwie opcje (Przejdź / Zostań), zapamiętanie decyzji w localStorage, jedno przypomnienie po N dniach.
  // Szuflada koszyka: „+ Dodaj” w bloku „Dobierz do zamówienia” — dodaje przez /cart/add.js i odświeża szufladę (Section Rendering, jak formularz produktu w Dawn)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var body = { id: Number(btn.dataset.upsellAdd), quantity: 1 };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) { btn.disabled = false; return; }
        if (drawer && state.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lorveni-upsell', productVariantId: body.id, cartData: state });
        }
      })
      .catch(function () { btn.disabled = false; });
  });

  if (!customElements.get('geo-banner')) {
    var parseJSON = function (el) { try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } };
    // nazwy krajów UE do testu ?geo_test=XX (docelowo nazwy i waluty pochodzą z aktywnych rynków Shopify)
    var DEMO_COUNTRIES = { AT: { name: 'Austria', currency: 'EUR' }, BE: { name: 'Belgia', currency: 'EUR' }, BG: { name: 'Bułgaria', currency: 'BGN' }, HR: { name: 'Chorwacja', currency: 'EUR' }, CY: { name: 'Cypr', currency: 'EUR' }, CZ: { name: 'Czechy', currency: 'CZK' }, DK: { name: 'Dania', currency: 'DKK' }, EE: { name: 'Estonia', currency: 'EUR' }, FI: { name: 'Finlandia', currency: 'EUR' }, FR: { name: 'Francja', currency: 'EUR' }, DE: { name: 'Niemcy', currency: 'EUR' }, GR: { name: 'Grecja', currency: 'EUR' }, HU: { name: 'Węgry', currency: 'HUF' }, IE: { name: 'Irlandia', currency: 'EUR' }, IT: { name: 'Włochy', currency: 'EUR' }, LV: { name: 'Łotwa', currency: 'EUR' }, LT: { name: 'Litwa', currency: 'EUR' }, LU: { name: 'Luksemburg', currency: 'EUR' }, MT: { name: 'Malta', currency: 'EUR' }, NL: { name: 'Holandia', currency: 'EUR' }, PL: { name: 'Polska', currency: 'PLN' }, PT: { name: 'Portugalia', currency: 'EUR' }, RO: { name: 'Rumunia', currency: 'RON' }, SK: { name: 'Słowacja', currency: 'EUR' }, SI: { name: 'Słowenia', currency: 'EUR' }, ES: { name: 'Hiszpania', currency: 'EUR' }, SE: { name: 'Szwecja', currency: 'SEK' } };
    var toFlag = function (code) { return String(code || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2); }; // kod kraju w plakietce (emoji flag nie działa na Windows)
    customElements.define('geo-banner', class extends HTMLElement {
      connectedCallback() {
        this.key = this.dataset.storageKey || 'lorveni_geo';
        this.countries = parseJSON(this.querySelector('[data-geo-countries]'));
        this.languages = parseJSON(this.querySelector('[data-geo-languages]'));
        this.current = (this.dataset.currentCountry || '').toUpperCase();
        this.currentLang = this.dataset.currentLanguage || '';
        this.querySelectorAll('[data-geo-stay]').forEach((b) => b.addEventListener('click', () => this.stay()));
        var form = this.querySelector('form');
        if (form) form.addEventListener('submit', () => this.remember({ decided: true }));
        // ręczna zmiana kraju/języka w stopce = decyzja użytkownika, więcej nie pytamy
        document.querySelectorAll('form.localization-form').forEach((f) => {
          if (f !== form) f.addEventListener('change', () => this.remember({ decided: true }));
        });
        var test = new URLSearchParams(window.location.search).get('geo_test');
      // tryb pokazu: ?geo_test=DE wlacza symulacje kraju na cala sesje karty, ?geo_test=off wylacza
      try {
        if (test === 'off') { sessionStorage.removeItem('lorveni_geo_test'); test = null; }
        else if (test) { sessionStorage.setItem('lorveni_geo_test', test); }
        else { test = sessionStorage.getItem('lorveni_geo_test'); }
      } catch (e) {}
      if (test) { this.suggest(test, null, true); return; }
        if (parseInt(this.dataset.countriesCount || '1', 10) < 2) return; // tylko jeden aktywny rynek — nie ma dokąd przełączać
        if (!this.shouldAsk()) return;
        fetch('/browsing_context_suggestions.json?source=geolocation_recommendation&country[enabled]=true&language[enabled]=true', { headers: { Accept: 'application/json' } })
          .then((r) => (r.ok ? r.json() : null))
          .then((d) => {
            var dv = d && d.detected_values ? d.detected_values : {};
            var c = dv.country && dv.country.handle;
            var l = dv.language && dv.language.handle;
            if (c) this.suggest(c, l);
          })
          .catch(function () {});
      }
      state() { try { return JSON.parse(localStorage.getItem(this.key) || '{}'); } catch (e) { return {}; } }
      remember(patch) { try { localStorage.setItem(this.key, JSON.stringify(Object.assign(this.state(), patch, { at: Date.now() }))); } catch (e) {} }
      shouldAsk() {
        var s = this.state();
        if (s.decided) return false;
        if (!s.stays) return true;
        var once = this.dataset.remindOnce === 'true';
        if (once && s.stays >= 2) return false;
        var days = parseInt(this.dataset.remindDays || '7', 10);
        return Date.now() - (s.at || 0) > days * 86400000;
      }
      suggest(code, lang, isTest) {
        code = String(code || '').toUpperCase();
        if (!code || code === this.current) return;
        var c = this.countries[code];
        if (!c && isTest) c = DEMO_COUNTRIES[code]; // podgląd banera, zanim rynki UE zostaną aktywowane
        if (!c) return;
        var langCode = lang && this.languages[lang] ? lang : this.currentLang;
        var vars = { country: c.name, currency: c.currency, language: this.languages[langCode] || langCode };
        this.querySelectorAll('[data-template]').forEach((el) => {
          el.textContent = (el.dataset.template || '').replace(/\{(country|currency|language)\}/g, function (_, k) { return vars[k]; });
        });
        var ci = this.querySelector('[data-geo-country-input]'); if (ci) ci.value = code;
        var li = this.querySelector('[data-geo-language-input]'); if (li) li.value = langCode;
        var flag = this.querySelector('[data-geo-flag]'); if (flag) flag.textContent = toFlag(code);
        setTimeout(() => { this.hidden = false; requestAnimationFrame(() => this.classList.add('is-visible')); }, parseInt(this.dataset.delay || '0', 10));
      }
      stay() { var s = this.state(); this.remember({ stays: (s.stays || 0) + 1 }); this.hide(); }
      hide() { this.classList.remove('is-visible'); setTimeout(() => { this.hidden = true; }, 300); }
    });
  }
})();
